/** Opções exibidas em reserva pública e no cadastro de passageiro (valor = texto salvo). */
export const FORMAS_PAGAMENTO = [
  'A VISTA ( PIX )',
  'CARTAO CREDITO',
  'DINHEIRO',
  'TRANSFERENCIA BANCARIA',
  'CARNÊ ( MEDIANTE ENTRADA )',
];

/** Carnê: aceita rótulos antigos ("Carnê") e novos ("CARNÊ ( MEDIANTE ENTRADA )"). */
export function formaIndicaCarne(forma) {
  if (!forma || typeof forma !== 'string') return false;
  return /carn[eê]/i.test(forma);
}

/** Texto em observações do pagamento (compatível com registros antigos e novos). */
export function observacoesIndicaCarne(observacoes) {
  if (!observacoes || typeof observacoes !== 'string') return false;
  return /carn[eê]/i.test(observacoes) || /\bParcelas:\s*\d/i.test(observacoes);
}
